
import { defineComponent } from 'vue';
import { GlobalAlertTypes } from '@momnt-technologies/common-ui/lib/plugins/alerts/types';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import { getBorrowerAgreement } from '@/api/loan';

export default defineComponent({
  name: 'BorrowerAgreementLink',

  components: { CustomButton },

  computed: {
    loanNumber(): string {
      return this.$store.getters['User/activeLoanNumber'];
    }
  },

  methods: {
    async open() {
      try {
        const { data } = await getBorrowerAgreement(this.loanNumber);
        if (data.borrower_agreement_url === null) throw Error('Invalid link');

        window.open(data.borrower_agreement_url, '_blank');
      } catch {
        this.$alerts.add({
          type: GlobalAlertTypes.ERROR,
          text: 'Error fetching Borrower Agreement',
          timed: true,
        });
      }
    }
  }
});
